module.exports = __webpack_public_path__ + "img/garage-open.83da4aa4.svg";